var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.3792C22.8284 13.3792 23.5 12.7076 23.5 11.8792C23.5 11.0507 22.8284 10.3792 22 10.3792L22 13.3792ZM0.93934 10.8185C0.353554 11.4043 0.353554 12.354 0.939341 12.9398L10.4853 22.4858C11.0711 23.0715 12.0208 23.0715 12.6066 22.4858C13.1924 21.9 13.1924 20.9502 12.6066 20.3644L4.12132 11.8792L12.6066 3.39387C13.1924 2.80808 13.1924 1.85834 12.6066 1.27255C12.0208 0.686763 11.0711 0.686763 10.4853 1.27255L0.93934 10.8185ZM22 10.3792L2 10.3792L2 13.3792L22 13.3792L22 10.3792Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.3e6c2494978e349425ab5be5a19f8d1a.svg";
export { ForwardRef as ReactComponent };